import { create } from 'zustand';
import type { Session, User } from '@supabase/supabase-js';

export type BridgeRole = 'senco' | 'teacher' | 'ta' | 'admin' | 'parent';

interface AuthState {
  session: Session | null;
  user: User | null;
  role: BridgeRole | null;
  isLoading: boolean;
  setSession: (session: Session | null) => void;
  setRole: (role: BridgeRole | null) => void;
  setLoading: (loading: boolean) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  session: null,
  user: null,
  role: null,
  isLoading: true,
  setSession: (session) =>
    set({
      session,
      user: session?.user ?? null,
      isLoading: false,
    }),
  setRole: (role) => set({ role }),
  setLoading: (isLoading) => set({ isLoading }),
  clear: () =>
    set({
      session: null,
      user: null,
      role: null,
      isLoading: false,
    }),
}));
